<div nxModalContent>
  <nx-card class="w-100 h-100">
    <nx-card-header>
      <h3 nxHeadline="subsection-small" class="nx-margin-bottom-s">
        {{'qrcodeModal.qrCodeModal' | caption}}
      </h3>
    </nx-card-header>
    <div nxLayout="grid">
      <div nxRow="">
        <div nxCol="12,12,6" class="text-center">

          <nx-data-display label="{{'qrcodeModal.updateLevel' | caption}}" orientation="vertical" class="nx-hidden-m nx-hidden-s nx-hidden-xs">
            @for (l of levelOptions; track l) {
              <button class="nx-margin-s " nxButton="{{l == level?'secondary':'cta'}} small" type="button" (click)="qrLevel(l)">{{l}}</button>
            }
          </nx-data-display>
        </div>
        <div nxCol="12,12, 6" class="text-center">
          <nx-data-display label="{{'qrcodeModal.updateWidth' | caption}}" orientation="vertical" class="nx-hidden-m nx-hidden-s nx-hidden-xs">
            @for (w of widthOptions; track w) {
              <button class="nx-margin-s " nxButton="{{w == width?'secondary':'cta'}} small" type="button" (click)="qrWidth(w)">{{w}}</button>
            }
          </nx-data-display>

        </div>
        <div nxCol="12" class="text-center">
          <qrcode [qrdata]="value" [width]="width" [errorCorrectionLevel]="level"></qrcode>
        </div>

      </div>
    </div>
  </nx-card>
</div>
<div nxModalActions>
  <button
    nxModalClose="cancel"
    class="nx-margin-bottom-0 nx-margin-right-xs"
    nxButton="small secondary"
    type="button"
    >
    {{'general.cancel' | caption}}
  </button>
</div>
